import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import IconButton from '../icon_button/iconButton';
import Logo from '../logo/Logo';
import MobileDrawer from '../mobile_drawer/MobileDrawer';
import { MobileContainer } from './navBar.styles';

export default function MobileNav({
  isSmallMobile,
  isDrawerOpen,
  toggleDrawer,
  drawerCategories,
  actions,
}) {
  return (
    <Box sx={MobileContainer}>
      <IconButton
        backgroundColor="secondary"
        color="#FFFFFF"
        hasBackground
        height={{ xs: '78px', lm: '78px', sm: '78px', md: '78px' }}
        onClick={toggleDrawer(true)}
        shape="square"
        size={isSmallMobile ? '44px' : '44px'}
        type="hamburgermenu"
        width={{ xs: '78px', lm: '78px', sm: '78px', md: '78px' }}
      />
      {/* Mobile Logo */}
      <Logo
        alt="California Casualty Header Logo"
        logoheight="55.1px"
        logowidth="267.44px"
        sx={{
          display: { xs: 'flex', lg: 'none' },
          px: { xs: '5px', sm: '10px' },
          width: "55%"
        }}
        actions={actions}
      />
      <MobileDrawer
        categories={drawerCategories}
        width={300}
        newOpen={isDrawerOpen}
        onClose={toggleDrawer(false)}
        actions={actions}
      />
    </Box>
  );
}

MobileNav.propTypes = {
  isSmallMobile: PropTypes.bool,
  isDrawerOpen: PropTypes.bool,
  toggleDrawer: PropTypes.func,
  drawerCategories: PropTypes.array,
};
